import { QueryKeys } from '@shared/domain/queryKeys'
import { useApiClient } from '@shared/hooks/useApiClient'
import { useQuery } from '@tanstack/react-query'
import type { Person } from '../domain/Bet.domain'

export const useGetPersons = () => {
  const api = useApiClient()

  return useQuery({
    queryKey: [QueryKeys.Persons],
    queryFn: async () => {
      const response = await api.get<Person[]>('/persons')
      return response.data
    },
  })
}
